<template>
    <div :class="['FaqItem', { 'is-opened': active }]">
		<button
			type="button"
			aria-label="Toggle FAQ answer"
			:aria-expanded="active"
			data-id="toggle-faq-answer"
			@click="emits('toggle')"
			:class="['FaqQuestion', { 'is-opened': active }]"
		>
            <span>{{ question }}</span>
			<span class="ToggleIconFaqButton">
				<i :class="['ToggleIconFaq', 'lnr-chevron-down']"></i>
			</span>
        </button>
		<div :class="[faqAnswer.FaqAnswerContainer, {[faqAnswer['is-opened']]: active}]">
			<div :class="faqAnswer.FaqAnswerContent">
				<div v-html="answer" :class="[faqAnswer.FaqAnswer]"></div>
			</div>
		</div>
    </div>
</template>
<script lang="ts" setup>
    const emits = defineEmits(['toggle']);
    const {id, question, answer, active} = defineProps({
        id: {
            type: Number,
            required: true,
        },
        question: {
            type: String,
            required: true,
        },
        answer: {
            type: String,
            required: true,
        },
        active: {
            type: Boolean,
            required: true,
        },
    });
</script>
<style module="faqAnswer" lang="scss">
	.FaqAnswerContainer {
		display: grid;
		grid-template-rows: 0fr;
		transition: grid-template-rows 0.24s ease-out;
		will-change: grid-template-rows;
		overflow: hidden;
		min-height: 0;

		.FaqAnswerContent {
			overflow: hidden;
			min-height: 0;
			display: flex;
			justify-content: flex-start;
			align-items: stretch;
			transition: padding 0.24s ease-out;
			width: 100%;
			min-width: 0;
		}

		&.is-opened {
			grid-template-rows: 1fr;
			overflow: hidden;
			border-bottom: 2px solid $Blue-700;

			.FaqAnswerContent {
				overflow: hidden;
				@include PaddingAreas(0);
			}
		}

		.FaqAnswer {
			@include TextStyle(BodyMediumRegular);
			@include MarginAreas(0);
			@include PaddingAreas(1.5, 0.5);

			&.Hidden {
				display: none;
			}

			a {
				color: $Blue-700;
				text-decoration: none;

				&:hover {
					text-decoration: underline;
				}
			}

			p {
				@include MarginAreas(0);
			}
			@include Breakpoint(Large, ExtraLarge) {
				@include PaddingAreas(1.5, 1);
			}
		}
	}
</style>
<style scoped lang="scss">
.FaqItem {
	background-color: $White;

	&.is-opened {
		background-color: $Grey-100;
	}

	button.FaqQuestion {
		outline: none;
		background: transparent;
		width: 100%;

		display: flex;
		justify-content: space-between;
		align-items: center;
		gap: 1rem;

		font-weight: 400;
		cursor: pointer;

		border: 2px solid transparent;
		box-sizing: border-box;
		transition: border-color 0.2s ease;
        @include PaddingAreas(1, 0.5);
		@include MarginAreas(0);

		.ToggleIconFaqButton {
			display: flex;
			align-items: center;

			color: $Grey-900;
			border: 1px solid $Grey-600;
			border-radius: 0.25rem;
            @include TextStyle(UiLargeRegular);
			@include PaddingAreas(0.5);
		}
		.ToggleIconFaq {
			transition: transform 0.3s ease;
		}

		&.is-opened {
            border-bottom: none;

			.ToggleIconFaqButton {
				color: $Blue-700;
				background-color: $Blue-100;
			}

			.ToggleIconFaq {
				transform: rotate(180deg);
			}

			&:hover {
				border-bottom: none;

				@include Breakpoint(Medium, Large, ExtraLarge) {
					.ToggleIconFaqButton {
						color: $Blue-700;
						background-color: $Blue-100;
						border: 1px solid $Blue-700;
					}
				}
			}
		}

		&:hover {

			@include Breakpoint(Medium, Large, ExtraLarge) {
				border-bottom: 2px solid $Blue-700;
				.ToggleIconFaqButton {
					color: $Blue-700;
					border-color: $Blue-700;
					background-color: $Blue-100;
				}
			}
		}
		@include Breakpoint(Large, ExtraLarge) {
			@include PaddingAreas(1.5, 1);
		}
	}

	.ToggleIconFaq {
		float: right;
	}
}
</style>